function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Notice from './notice';
var prefixCls = 'eui-toast';

var Notification = /*#__PURE__*/function (_Component) {
  _inherits(Notification, _Component);

  var _super = _createSuper(Notification);

  function Notification() {
    var _this;

    _classCallCheck(this, Notification);

    _this = _super.call(this);
    _this.transitionTime = 300;
    _this.state = {
      notices: []
    };
    _this.removeNotice = _this.removeNotice.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Notification, [{
    key: "getNoticeKey",
    value: function getNoticeKey() {
      var notices = this.state.notices;
      return "notice-".concat(new Date().getTime(), "-").concat(notices.length);
    }
  }, {
    key: "addNotice",
    value: function addNotice(notice) {
      var _this2 = this;

      var notices = this.state.notices;
      notice.key = this.getNoticeKey();

      if (notices.every(function (item) {
        return item.key !== notice.key;
      })) {
        if (notice.length > 0 && notices[notice.length - 1].type === 'loading') {
          notices.push(notice);
          setTimeout(function () {
            _this2.setState({
              notices: notices
            });
          }, this.transitionTime);
        } else {
          notices.push(notice);
          this.setState({
            notices: notices
          });
        }

        if (notice.duration > 0) {
          setTimeout(function () {
            _this2.removeNotice(notice.key);
          }, notice.duration);
        }
      }

      return function () {
        _this2.removeNotice(notice.key);
      };
    }
  }, {
    key: "removeNotice",
    value: function removeNotice(key) {
      var _this3 = this;

      var notices = this.state.notices;
      this.setState({
        notices: notices.filter(function (notice) {
          if (notice.key === key) {
            if (notice.onClose) setTimeout(notice.onClose, _this3.transitionTime);
            return false;
          }

          return true;
        })
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var notices = this.state.notices;
      return /*#__PURE__*/React.createElement(TransitionGroup, {
        className: "".concat(prefixCls, "-notification")
      }, notices.map(function (notice) {
        return /*#__PURE__*/React.createElement(CSSTransition, {
          key: notice.key,
          classNames: "eui-toast-notice-wrapper notice",
          timeout: _this4.transitionTime
        }, /*#__PURE__*/React.createElement(Notice, notice));
      }));
    }
  }]);

  return Notification;
}(Component);

function createNotification() {
  var div = document.createElement('div');
  document.body.appendChild(div);
  var ref = React.createRef();
  ReactDOM.render( /*#__PURE__*/React.createElement(Notification, {
    ref: ref
  }), div);
  return {
    addNotice: function addNotice(notice) {
      return ref.current.addNotice(notice);
    },
    destroy: function destroy() {
      ReactDOM.unmountComponentAtNode(div);
      document.body.removeChild(div);
    }
  };
}

export default createNotification();